import { render, staticRenderFns } from "./AccountMenu.vue?vue&type=template&id=85355d3e&scoped=true"
import script from "./AccountMenu.vue?vue&type=script&lang=ts"
export * from "./AccountMenu.vue?vue&type=script&lang=ts"
import style0 from "./AccountMenu.vue?vue&type=style&index=0&id=85355d3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85355d3e",
  null
  
)

export default component.exports